import { s3URL } from '@mathflat/common/util'
import { action, makeAutoObservable, makeObservable, observable } from 'mobx'
import { TOAST_STR } from 'src/constant'
import { Academy } from 'src/dto'
import modalService from 'src/service/modal.service'

import { academyController } from '@/controller/academy.controller'
import commonRepo from '@/repository/common.repo'
import { toastError, toastSuccess } from '@/utils/toast'

type LogoOptions = 'MATHFLAT' | 'ACADEMY' | 'NONE'

export class LogoType {
  logoRadioOption: LogoOptions
  logoImgUrl: string | ArrayBuffer
  emptyMessage?: string
  fileSize: number
  constructor(data) {
    makeAutoObservable(this)
    this.logoRadioOption = data.logoRadioOption
    this.logoImgUrl = data.logoImgUrl
    this.emptyMessage = data.emptyMessage
    this.fileSize = 0
  }
}
export default class AcademyOptionsService {
  academy: Academy = new Academy()
  logoFile?: File
  optionMathflat = new LogoType({
    logoRadioOption: 'MATHFLAT',
    logoImgUrl: s3URL.mathflatAssetsBucket.teacher(`assets/${commonRepo.appName}_logo.png`),
  })
  optionAcademy = new LogoType({
    logoRadioOption: 'ACADEMY',
    logoImgUrl: '',
    emptyMessage: '로고 이미지를 등록해주세요.',
  })
  optionNone = new LogoType({
    logoRadioOption: 'NONE',
    logoImgUrl: '',
    emptyMessage: '로고 없음',
  })
  selectedLogoType: LogoType = this.optionMathflat
  constructor() {
    makeObservable(this, {
      selectedLogoType: observable,
      academy: observable,
      getLogoType: action,
      fetchMyAcademy: action,
      changeMyAcademy: action,
      changeLogoFile: action,
      modifyAcademyLogo: action,
    })
    if (commonRepo.academy) {
      this.selectedLogoType = this.getLogoType(commonRepo.academy)
    }
  }

  initAcademyOption = () => {
    return new LogoType({
      logoRadioOption: 'ACADEMY',
      logoImgUrl: '',
      emptyMessage: '로고 이미지를 등록해주세요.',
    })
  }

  getLogoType = (academy: Academy) => {
    switch (academy.logoOperation) {
      case 'REPLACE': {
        this.optionAcademy.logoImgUrl = academy.logoUrlAdjusted
        return this.optionAcademy
      }
      case 'DELETE': {
        this.optionAcademy = this.initAcademyOption()
        return this.optionNone
      }
      case 'REPLACE_DEFAULT': {
        this.optionAcademy = this.initAcademyOption()
        return this.optionMathflat
      }
      default:
        this.optionAcademy = this.initAcademyOption()
        return this.optionMathflat
    }
  }

  fetchMyAcademy = async () => {
    try {
      this.academy = await academyController.fetchMyAcademy()
      this.academy.logoUrlDateNow = Date.now() //로고 업데이트 후에 이미지 캐싱날리도록 뒤에 난수 추가하는 로직의 난수값
      commonRepo.academy?.update(this.academy)
    } catch (e) {
      toastError(TOAST_STR.errorMessage)
    }
  }

  changeMyAcademy = async (academy: Academy) => {
    try {
      await academyController.changeMyAcademy(academy)
      await this.fetchMyAcademy()
      modalService.closeModal()
      toastSuccess(TOAST_STR.modify)
    } catch (e) {
      toastError(TOAST_STR.errorMessage)
    }
  }

  changeLogoFile = (logoFile: File) => {
    this.logoFile = logoFile
  }

  modifyAcademyLogo = async (selectedLogoType: LogoType) => {
    const formdata = new FormData()
    let operation = ''
    switch (selectedLogoType.logoRadioOption) {
      case 'MATHFLAT':
        operation = 'REPLACE_DEFAULT'
        break
      case 'ACADEMY':
        operation = 'REPLACE'
        break
      case 'NONE':
        operation = 'DELETE'
        break
    }
    formdata.append('operation', operation)
    if (this.logoFile) {
      formdata.append('logoFile', this.logoFile)
    }
    try {
      await academyController.changeMyAcademyLogo(formdata)
      await this.fetchMyAcademy()
      if (commonRepo.academy) {
        this.selectedLogoType = this.getLogoType(commonRepo.academy)
      }
      modalService.closeModal()
      toastSuccess(TOAST_STR.changeLogoFile)
    } catch (e) {
      toastError(TOAST_STR.errorMessage)
    }
  }

  modifyAcademyCustomerType = async (customerType: Academy['customerType']) => {
    try {
      await academyController.changeCustomerType({ customerType })
      this.academy.setCustomerType(customerType)
      toastSuccess(TOAST_STR.customerTypeModify)
    } catch (e) {
      toastError(TOAST_STR.errorMessage)
    }
  }
}
